import React, { forwardRef } from "react";
import { motion } from "framer-motion";
import { cn } from "../../utils/cn";

/**
 * Scene shell with a real scrollbar. Clicks stay blocked on product UI
 * (pointer-events-none on content), but the scroll container receives wheel/touch.
 * Bottom padding clears the floating tour controls.
 */
const PresentationCanvas = forwardRef(function PresentationCanvas(
  { children, className },
  ref
) {
  return (
    <motion.div
      ref={ref}
      className={cn(
        "relative flex h-full min-h-0 w-full flex-col overflow-hidden select-none",
        className
      )}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
    >
      <div
        className={cn(
          "h-full min-h-0 flex-1 overflow-y-auto overscroll-y-contain",
          "p-2 sm:p-3 pb-[7.5rem] sm:pb-[8.25rem]"
        )}
      >
        <div className="pointer-events-none flex min-h-full flex-col">
          {children}
        </div>
      </div>
    </motion.div>
  );
});

export default PresentationCanvas;
